import { render, staticRenderFns } from "./History.vue?vue&type=template&id=d488fd94&scoped=true&"
import script from "./History.vue?vue&type=script&lang=js&"
export * from "./History.vue?vue&type=script&lang=js&"
import style0 from "./History.vue?vue&type=style&index=0&id=d488fd94&scoped=true&lang=scss&"
import style1 from "./History.vue?vue&type=style&index=1&id=d488fd94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d488fd94",
  null
  
)

export default component.exports